export const CENTIMETERS_TO_METERS = 100;
export const CENTIMETERS_TO_INCHES = 2.54;
export const METERS_TO_INCHES = 0.0254;
export const INCHES_TO_FEET = 12;
export const KILO_TO_POUND = 0.454;
export const CUBICMETERS_TO_CUBICFEET = 0.0283;

export enum UD_TYPES {
  CENTIMETERS = 'cm',
  METERS = 'm',
  INCHES = 'in',
  FEET = 'ft',
  KILOS = 'kg',
  POUNDS = 'lb',
  CUBICMETERS = 'm³',
  CUBICFEET = 'ft³',
  WATTS = 'W',
  LUMENS = 'lm',
}

export const UD_DESCRIPTIONS = {
  [UD_TYPES.CENTIMETERS]: {
    es: {
      singular: 'centimetro',
      plural: 'centimetros',
    },
    en: {
      singular: 'centimeter',
      plural: 'centimeters',
    },
    short: UD_TYPES.CENTIMETERS,
  },
  [UD_TYPES.METERS]: {
    es: {
      singular: 'metro',
      plural: 'metros',
    },
    en: {
      singular: 'meter',
      plural: 'meters',
    },
    short: UD_TYPES.METERS,
  },
  [UD_TYPES.INCHES]: {
    es: {
      singular: 'pulgada',
      plural: 'pulgadas',
    },
    en: {
      singular: 'inch',
      plural: 'inches',
    },
    short: '"',
  },
  [UD_TYPES.CUBICMETERS]: {
    es: {
      singular: 'metro cúbico',
      plural: 'metros cúbicos',
    },
    en: {
      singular: 'cubic meter',
      plural: 'cubic meters',
    },
    short: UD_TYPES.CUBICMETERS,
  },
  [UD_TYPES.CUBICFEET]: {
    es: {
      singular: 'pie cúbico',
      plural: 'pies cúbicos',
    },
    en: {
      singular: 'cubic foot',
      plural: 'cubic feet',
    },
    short: UD_TYPES.CUBICFEET,
  },
  [UD_TYPES.WATTS]: {
    es: {
      singular: 'watt',
      plural: 'watts',
    },
    en: {
      singular: 'watt',
      plural: 'watts',
    },
    short: UD_TYPES.WATTS,
  },
  [UD_TYPES.LUMENS]: {
    es: {
      singular: 'lummen',
      plural: 'lummens',
    },
    en: {
      singular: 'lummen',
      plural: 'lummens',
    },
    short: UD_TYPES.LUMENS,
  },
  [UD_TYPES.KILOS]: {
    es: {
      singular: 'kilo',
      plural: 'kilos',
    },
    en: {
      singular: 'kilo',
      plural: 'kilos',
    },
    short: UD_TYPES.KILOS,
  },
  [UD_TYPES.POUNDS]: {
    es: {
      singular: 'libra',
      plural: 'libras',
    },
    en: {
      singular: 'pound',
      plural: 'pounds',
    },
    short: UD_TYPES.POUNDS,
  },
};
